import { createContext } from 'react';

const ModalContext = createContext()

export { ModalContext }
